import { createFileRoute } from "@tanstack/react-router";
import { SERVICE_BY_SLUG } from "@/lib/services";
import { ServicePageTemplate } from "@/components/site/ServicePageTemplate";
import { faqSchema, serviceSchema, breadcrumbSchema } from "@/components/site/SchemaJsonLd";

const service = SERVICE_BY_SLUG["phoenix-plumbing-contractors"];

export const Route = createFileRoute("/phoenix-plumbing-contractors")({
  head: () => ({
    meta: [
      { title: service.title },
      { name: "description", content: service.description },
      { property: "og:title", content: service.title },
      { property: "og:description", content: service.description },
      { property: "og:url", content: "https://www.phoenixplumbing.co/phoenix-plumbing-contractors" },
      { name: "twitter:title", content: service.title },
      { name: "twitter:description", content: service.description },
    ],
    links: [{ rel: "canonical", href: "https://www.phoenixplumbing.co/phoenix-plumbing-contractors" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(serviceSchema(service.name, service.description)) },
      { type: "application/ld+json", children: JSON.stringify(faqSchema(service.faqs)) },
      { type: "application/ld+json", children: JSON.stringify(breadcrumbSchema([{ name: "Home", url: "/" }, { name: "Phoenix Plumbing Contractors", url: "/phoenix-plumbing-contractors" }])) },
    ],
  }),
  component: () => <ServicePageTemplate service={service} />,
});